import { AtomicBlockUtils, } from 'wix-rich-content-editor-common';
import { getDefaultComponentData } from './types';
export var attachImage = function (deviation, editorState) {
    var data = getDefaultComponentData();
    data.data = deviation;
    // Create the entity
    var contentState = editorState.getCurrentContent();
    var contentStateWithEntity = contentState.createEntity('wix-draft-plugin-image', 'IMMUTABLE', data);
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    // Insert a new block
    var newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    var recentlyCreatedKey = newEditorState.getSelection().getAnchorKey();
    var newBlock = newEditorState
        .getCurrentContent()
        .getBlockBefore(recentlyCreatedKey);
    // Component has block key update it by ref.
    data.config.key = newBlock === null || newBlock === void 0 ? void 0 : newBlock.getKey();
    return newEditorState;
};
//# sourceMappingURL=modifiers.js.map